import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import RoutesApp from './routesApp';
import Navbar from './components/Navbar';
import { SnackbarProvider } from 'notistack';

function AppContent() {
  const location = useLocation();
  const hideNavbar = location.pathname === '/' || location.pathname === '/register' || location.pathname === '*';

  return (
    <>
      {!hideNavbar && <Navbar />}
      <RoutesApp/>
    </>
  );
}

function App() {
  return (
    <SnackbarProvider>
      <Router>
        <AppContent/>
      </Router>
    </SnackbarProvider>
  );
}

export default App;
